// product-media-fix.js
// Sets --gallery-viewer-height on each media-gallery element so the main
// image viewer + 30px gap + thumbnail strip fit within 100vh.
// Only active on desktop (>=750px). Reruns on resize.

(function () {
  const GAP = 30;
  const MIN_VIEWER_HEIGHT = 300;

  function setGalleryHeight() {
    if (window.innerWidth < 750) return;

    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      var thumbSlider = gallery.querySelector('slider-component.thumbnail-slider');
      var thumbHeight = thumbSlider ? thumbSlider.offsetHeight : 0;
      var viewerHeight = Math.max(
        MIN_VIEWER_HEIGHT,
        window.innerHeight - thumbHeight - GAP
      );
      gallery.style.setProperty('--gallery-viewer-height', viewerHeight + 'px');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setGalleryHeight);
  } else {
    setGalleryHeight();
  }

  window.addEventListener('resize', setGalleryHeight);
})();
